import Welcome from './'

export default [
    {
      path: "/",
      component: Welcome,
      name: "Index",
      meta: {
        module: "Index",
        title: "Главная",
      },
    },
]